import type { ComponentType, SVGProps } from "react";
import {
  ArrowDownCircle,
  ArrowLeftRight,
  ArrowUpCircle,
  BadgeDollarSign,
  Banknote,
  BookOpenCheck,
  Boxes,
  Briefcase,
  Building2,
  Calculator,
  Calendar,
  CalendarClock,
  ClipboardCheck,
  ClipboardList,
  Contact,
  CreditCard,
  FileBarChart,
  FileChartColumn,
  FileCheck2,
  FileCode,
  FileQuestion,
  FileSignature,
  FileSpreadsheet,
  Fingerprint,
  GanttChartSquare,
  Hash,
  Heart,
  History,
  Info,
  Kanban,
  KeyRound,
  Landmark,
  LayoutGrid,
  Lightbulb,
  ListChecks,
  Megaphone,
  MessageCircle,
  MessagesSquare,
  Package,
  Package2,
  PackageSearch,
  Palette,
  Percent,
  PiggyBank,
  Receipt,
  Repeat2,
  Ruler,
  Scale,
  ScrollText,
  Send,
  Server,
  Settings,
  ShieldCheck,
  ShoppingBag,
  ShoppingCart,
  SlidersHorizontal,
  Smartphone,
  Sparkles,
  SquareStack,
  Star,
  Store,
  Tags,
  Ticket,
  Truck,
  UserCog,
  UserRound,
  Users,
  Wallet,
  Warehouse,
  Workflow,
  Wrench,
} from "lucide-react";

export type IconeMenu = ComponentType<SVGProps<SVGSVGElement>>;

/**
 * Todos os ícones lucide-react disponíveis para representar uma tela do sistema —
 * usados no menu lateral (iconesMenu.ts), no seletor de ícone da aba "Versão do
 * Sistema" e no painel de Notificações (aba Novidades). Uma única fonte evita que
 * os três lugares fiquem com conjuntos de ícones divergentes.
 */
export const ICONES_DISPONIVEIS: Record<string, IconeMenu> = {
  ArrowDownCircle,
  ArrowLeftRight,
  ArrowUpCircle,
  BadgeDollarSign,
  Banknote,
  BookOpenCheck,
  Boxes,
  Briefcase,
  Building2,
  Calculator,
  Calendar,
  CalendarClock,
  ClipboardCheck,
  ClipboardList,
  Contact,
  CreditCard,
  FileBarChart,
  FileChartColumn,
  FileCheck2,
  FileCode,
  FileQuestion,
  FileSignature,
  FileSpreadsheet,
  Fingerprint,
  GanttChartSquare,
  Hash,
  Heart,
  History,
  Info,
  Kanban,
  KeyRound,
  Landmark,
  LayoutGrid,
  Lightbulb,
  ListChecks,
  Megaphone,
  MessageCircle,
  MessagesSquare,
  Package,
  Package2,
  PackageSearch,
  Palette,
  Percent,
  PiggyBank,
  Receipt,
  Repeat2,
  Ruler,
  Scale,
  ScrollText,
  Send,
  Server,
  Settings,
  ShieldCheck,
  ShoppingBag,
  ShoppingCart,
  SlidersHorizontal,
  Smartphone,
  Sparkles,
  SquareStack,
  Star,
  Store,
  Tags,
  Ticket,
  Truck,
  UserCog,
  UserRound,
  Users,
  Wallet,
  Warehouse,
  Workflow,
  Wrench,
};

/** Resolve o nome salvo no banco (ex.: "Package") para o componente de ícone lucide correspondente. */
export function obterIconePorNome(nome: string | null | undefined): IconeMenu | null {
  if (!nome) return null;
  return ICONES_DISPONIVEIS[nome] ?? null;
}
